(function () {
  if (window.MondayAnnouncementBarRotator) {
    window.MondayAnnouncementBarRotator.initAll(document);
    return;
  }

  var ROTATOR_SELECTOR = '[data-announcement-rotator]';
  var DEFAULT_INTERVAL = 5000;
  var instances = new WeakMap();

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function getItemText(item) {
    var message = item.querySelector('[data-announcement-message]');
    return normalizeText(message ? message.textContent : item.textContent);
  }

  function getInterval(rotator) {
    var interval = parseInt(rotator.getAttribute('data-rotation-interval'), 10);
    return Number.isFinite(interval) && interval > 0 ? interval : DEFAULT_INTERVAL;
  }

  function setItemFocusable(item, isFocusable) {
    if (item.tagName === 'A') {
      if (isFocusable) {
        item.removeAttribute('tabindex');
      } else {
        item.setAttribute('tabindex', '-1');
      }
    }
  }

  function render(state) {
    var activeItem = state.validItems[state.currentIndex];

    state.items.forEach(function (item) {
      var isValid = state.validItems.indexOf(item) !== -1;
      var isActive = item === activeItem;

      item.hidden = !isValid;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      setItemFocusable(item, isActive);
    });

    [state.previousButton, state.nextButton].forEach(function (button) {
      if (!button) return;

      var hasControls = state.validItems.length > 1;
      button.hidden = !hasControls;
      button.disabled = !hasControls;
    });

    state.rotator.setAttribute('data-announcement-count', state.validItems.length);
  }

  function stop(state) {
    if (!state.timer) return;

    window.clearInterval(state.timer);
    state.timer = null;
  }

  function start(state) {
    if (state.timer || state.paused || state.validItems.length <= 1) return;

    state.timer = window.setInterval(function () {
      goTo(state, state.currentIndex + 1, false);
    }, state.interval);
  }

  function restart(state) {
    stop(state);
    start(state);
  }

  function syncItems(state) {
    var activeItem = state.validItems[state.currentIndex] || state.rotator.querySelector('[data-announcement-item].is-active');

    state.items = Array.prototype.slice.call(state.rotator.querySelectorAll('[data-announcement-item]'));
    state.validItems = state.items.filter(function (item) {
      return getItemText(item) !== '';
    });

    if (activeItem && state.validItems.indexOf(activeItem) !== -1) {
      state.currentIndex = state.validItems.indexOf(activeItem);
    } else {
      state.currentIndex = 0;
    }

    render(state);

    if (state.validItems.length > 1) {
      restart(state);
    } else {
      stop(state);
    }
  }

  function goTo(state, index, isManual) {
    if (!state.validItems.length) return;

    state.currentIndex = (index + state.validItems.length) % state.validItems.length;
    render(state);

    if (isManual) {
      restart(state);
    }
  }

  function syncGlobalEText(state) {
    if (!state.globalText) {
      syncItems(state);
      return;
    }

    var banner = state.globalSource ? state.globalSource.querySelector('#FreeShippingBanner') : null;
    var bannerText = normalizeText(banner ? banner.textContent : '');

    // Only replace when Global-e injects copy; otherwise keep the Liquid default.
    if (bannerText && state.globalText.textContent !== bannerText) {
      state.globalText.textContent = bannerText;
    }

    syncItems(state);
  }

  function addListener(state, target, eventName, handler) {
    if (!target) return;

    target.addEventListener(eventName, handler);
    state.cleanups.push(function () {
      target.removeEventListener(eventName, handler);
    });
  }

  function observeGlobalE(state) {
    if (!state.globalSource) return;

    var sourceObserver = new MutationObserver(function () {
      syncGlobalEText(state);
    });

    sourceObserver.observe(state.globalSource, {
      childList: true,
      characterData: true,
      subtree: true
    });

    state.observers.push(sourceObserver);
  }

  function init(rotator) {
    if (!rotator || instances.has(rotator)) return;

    var center = rotator.closest('[data-announcement-bar-center]');
    var state = {
      rotator: rotator,
      previousButton: rotator.querySelector('[data-announcement-previous]'),
      nextButton: rotator.querySelector('[data-announcement-next]'),
      globalText: rotator.querySelector('[data-announcement-global-e] [data-announcement-message]'),
      globalSource: center ? center.querySelector('[data-announcement-global-e-source]') || document.getElementById('geFSBContainer') : document.getElementById('geFSBContainer'),
      items: [],
      validItems: [],
      currentIndex: 0,
      interval: getInterval(rotator),
      timer: null,
      paused: false,
      observers: [],
      cleanups: []
    };

    instances.set(rotator, state);
    rotator.setAttribute('data-initialized', 'true');

    addListener(state, state.previousButton, 'click', function () {
      goTo(state, state.currentIndex - 1, true);
    });

    addListener(state, state.nextButton, 'click', function () {
      goTo(state, state.currentIndex + 1, true);
    });

    addListener(state, center, 'mouseenter', function () {
      state.paused = true;
      stop(state);
    });

    addListener(state, center, 'mouseleave', function () {
      state.paused = false;
      start(state);
    });

    addListener(state, center, 'focusin', function () {
      state.paused = true;
      stop(state);
    });

    addListener(state, center, 'focusout', function (event) {
      if (center && center.contains(event.relatedTarget)) return;

      state.paused = false;
      start(state);
    });

    observeGlobalE(state);
    syncGlobalEText(state);
  }

  function destroy(rotator) {
    var state = instances.get(rotator);
    if (!state) return;

    stop(state);

    state.observers.forEach(function (observer) {
      observer.disconnect();
    });

    state.cleanups.forEach(function (cleanup) {
      cleanup();
    });

    instances.delete(rotator);
  }

  function initAll(scope) {
    var root = scope || document;

    if (root.matches && root.matches(ROTATOR_SELECTOR)) {
      init(root);
    }

    root.querySelectorAll(ROTATOR_SELECTOR).forEach(init);
  }

  window.MondayAnnouncementBarRotator = {
    initAll: initAll,
    destroy: destroy
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(ROTATOR_SELECTOR).forEach(destroy);
  });
})();
